import React from "react"
import styled from "styled-components"
import { Link, StaticQuery, graphql } from "gatsby"
import { Settings } from "../../../styles/theme"
import { Grid } from "../../atoms/grid"

const Exhibitorstyle = styled.div`
  position: relative;
  a {
    text-decoration: none;
    color: #000;
    > div {
      align-items: stretch;
    }
  }
  h4 {
    color: ${Settings.primaryColor};
    text-transform: uppercase;
    font-weight: 700;
  }
  .boothNumber {
    color: #fff;
    background: ${Settings.primaryColor};
    padding: 0;
    text-align: center;
    border-radius: 3px;
  }
`

class ExhibitorsShard extends React.Component {
  render() {
    return (
      <Exhibitorstyle>
        <div className="constraint">
          {this.props.data.allContentfulExhibitorNews.edges.map((news, i) => (
            <Link
              to={
                "/exhibitor-news/" +
                news.node.title
                  .replace(/\s+/g, "-")
                  .replace(/[!@#$%^&*?]/g, "")
                  .toLowerCase()
              }
              key={i}
            >
              <Grid unstack>
                <div style={{ flex: " 1 1 93%" }}>
                  <h4>{news.node.title}</h4>
                  <p>
                    <b>{news.node.exhibitor}</b> | {news.node.publishedDate}
                  </p>
                  <p>{news.node.description.description}</p>
                </div>
                <div style={{ flex: " 1 1 7%" }}>
                  <h4 className="boothNumber">{news.node.boothNumber}</h4>
                </div>
              </Grid>
              <hr
                style={{
                  opacity: "0.5",
                  margin: "2rem 0 1rem",
                  border: "none",
                  borderTop: "1px solid #000",
                }}
              />
            </Link>
          ))}
        </div>
      </Exhibitorstyle>
    )
  }
}

export const ExhibitorsNewsroom = () => (
  <StaticQuery
    query={graphql`
      query ExhibitorQuery {
        allContentfulExhibitorNews {
          edges {
            node {
              title
              exhibitor
              boothNumber
              description {
                description
              }
              publishedDate(formatString: "DD MMMM YYYY")
            }
          }
        }
      }
    `}
    render={data => <ExhibitorsShard data={data} />}
  />
)
